import {Button} from '@chakra-ui/react'
import {faArrowLeft} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useRouter} from 'next/router'

interface Props {
  onClick?: () => void
}

const BackButton = ({onClick}: Props) => {
  const router = useRouter()

  return (
    <Button variant='back' onClick={() => (onClick ? onClick() : router.back())} aria-label='Back'>
      <FontAwesomeIcon icon={faArrowLeft} />
    </Button>
  )
}

export default BackButton
